// removed by extract-text-webpack-plugin
module.exports = {"colorField":"CwColorField-colorField","colorFieldTriggerField":"CwColorField-colorFieldTriggerField","swatchSelected":"CwColorField-swatchSelected"};


//////////////////
// WEBPACK FOOTER
// ./src/components/cwcolorfield/CwColorField.scss
// module id = 355
// module chunks = 0